// Styles
import { StyledContent } from '@/styles/shared.styles';

export default function Welcome({}) {
	return <StyledContent></StyledContent>;
}
